export const FIRM_DOCUMENT_UPLOAD_DIALOG_TEST_IDS = {
  cancelButton: 'firm-document-upload-dialog-cancel',
  closeButton: 'firm-document-upload-dialog-close',
  companyMenu: 'firm-document-upload-dialog-company-menu',
  companyOption: (id: number) => `firm-document-upload-dialog-company-${id}`,
  companySearch: 'firm-document-upload-dialog-company-search',
  companySelect: 'firm-document-upload-dialog-company-select',
  dialog: 'firm-document-upload-dialog',
  dropzone: 'firm-document-upload-dialog-dropzone',
  fileInput: 'firm-document-upload-dialog-file',
  folderMenu: 'firm-document-upload-dialog-folder-menu',
  folderOption: (id: number | null) => `firm-document-upload-dialog-folder-${id ?? 'root'}`,
  folderSearch: 'firm-document-upload-dialog-folder-search',
  folderSelect: 'firm-document-upload-dialog-folder-select',
  measurementDateMenu: 'firm-document-upload-dialog-measurement-date-menu',
  measurementDateOption: (id: number) => `firm-document-upload-dialog-measurement-date-${id}`,
  measurementDateSearch: 'firm-document-upload-dialog-measurement-date-search',
  measurementDateSelect: 'firm-document-upload-dialog-measurement-date-select',
  rejectedFile: (index: number) => `firm-document-upload-dialog-rejected-file-${index}`,
  removeSelectedFile: (index: number) => `firm-document-upload-dialog-remove-selected-file-${index}`,
  selectedFile: (index: number) => `firm-document-upload-dialog-selected-file-${index}`,
  totalProgress: 'firm-document-upload-dialog-total-progress',
  uploadButton: 'firm-document-upload-dialog-upload',
} as const;
